export default __webpack_public_path__ + "static/media/id-card.dc56fee7.svg";